import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4737a869"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fieldWrapper field" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "inputRow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "mt-2 is-flex is-flex-wrap-wrap" }
const _hoisted_11 = { class: "badgeLabel" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "list-group-item"
}

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormStringListField',
  props: {
    modelValue: null,
    label: null,
    description: null,
    noneMessage: null,
    icon: null,
    trimmed: { type: Boolean },
    size: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: string[],
  label?: string,
  description?: string,
  noneMessage?: string,
  icon?: string,
  trimmed?: boolean,
  size?: "large"|"small"
}



const newItem = ref<string>("");
const items = ref<string[]>([]);

// Event for two-way binding


const addItem = () => {
  if (props.trimmed) {
    newItem.value = newItem.value.trim();
  }
  
  if (newItem.value.length == 0) return;
  if (!items.value) { 
    items.value = [newItem.value];
  } else {
    items.value.push(newItem.value);
  }
  newItem.value = "";
  onInput();
}

const removeItem = (i: number) => {
  items.value.splice(i,1);
  onInput();
}

const onInput = () => {
  emit('update:modelValue', items.value);
};

onMounted(() => {
  items.value = [...props.modelValue];
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          ref: "inputElem",
          class: "input",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newItem).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (addItem()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            newItem.value,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("button", {
          type: "submit",
          value: "Save",
          class: "button is-link is-small ml-1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addItem()))
        }, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "mr-2"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["tag is-light is-rounded has-text-weight-bold", {'is-large':__props.size=='large'}])
            }, [
              (__props.icon)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(["fas fa-lg mr-3", __props.icon])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["delete ml-2", {'is-large':__props.size=='large'}]),
                role: "button",
                onClick: ($event: any) => (removeItem(idx))
              }, "(x)", 10, _hoisted_12)
            ], 2)
          ]))
        }), 128)),
        (items.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(__props.noneMessage || 'None specified.'), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})